import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase } from '@digibricks/core';
import { Title } from '../../../../core';
export var UPDATE_FORM_TITLE_USE_CASE = 'UPDATE_FORM_TITLE_USE_CASE';
export var UPDATE_FORM_INFORMATION_USE_CASE = 'UPDATE_FORM_INFORMATION_USE_CASE';
export var UpdateFormUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateFormUseCase, _UseCase);

  var _super = _createSuper(UpdateFormUseCase);

  function UpdateFormUseCase(formRepository) {
    var _this;

    _classCallCheck(this, UpdateFormUseCase);

    _this = _super.call(this);
    _this.formRepository = formRepository;
    return _this;
  }

  _createClass(UpdateFormUseCase, [{
    key: "validate",
    value: function validate(useCaseInput) {
      var input = useCaseInput.input;
      var title = input.title,
          tags = input.tags;

      if (title !== undefined && !Title.isValidInput(title, Title.formMaxLength)) {
        return Result.fail("Title is required and must not exceed ".concat(Title.formMaxLength, " characters"));
      }

      if (tags && tags.length < 0) {
        return Result.fail('Tags is required');
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var resultOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resultOrError = this.validate(useCaseInput);

                if (!resultOrError.isFailure) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.fail(resultOrError.error));

              case 3:
                _context.next = 5;
                return this.formRepository.update(useCaseInput);

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return UpdateFormUseCase;
}(UseCase);